module.exports = __webpack_public_path__ + "img/mobile-share-report.e317d077.png";